import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/GameTimeline/cards-blank-duotone-solid.svg";

export function CardsBlankDuotoneSolid(props: SxProps) {
    return (
        <SvgIcon
            component={Icon}
            inheritViewBox
            sx={{ width: "100%", height: "100%", ...props }}
        />
    );
}
